import styled from 'styled-components'
import Logo from '../../assets/cubsec-larmcentral-logotype.svg'


export const Center = styled.header`
  text-align: center;
  padding: ${({ theme }) => theme.gutterLarge} 0;
`
export const Logotype = styled(Logo)`
  width: 200px;
  height: 52px;
`

export const Content = styled.div`
  padding-top: ${({ theme }) => theme.gutterLarge};
  max-width: 75%;
  margin: 0 auto;
`
